module.exports = __webpack_public_path__ + "static/media/Union.b7e98bda.svg";